
export const initialValues = {
  divisionId: "",
  zoneName: "",
  stateId: "",
  activeStatus: 1,

}